export default __webpack_public_path__ + "static/media/logo-white.14ecb051.svg";